export const SAVE_SEARCH_ACTION_LABEL = "Save these filters as a search";
